<template>
    <div class="SuccessAlert animated fadeInRight" :class="{ fadeOutRight: hide, hidden: hidden }">
        <i class="fa fa-check-circle"></i> &nbsp; Gemt
    </div>
</template>

<style>
.SuccessAlert {
    display: inline-block;
    margin-right: 20px;
}
</style>

<script type="text/babel">
export default {
    data() {
        return {
            hide: false,
            hidden: false,
        }
    },

    created() {
        setTimeout(() => (this.hide = true), 3000)
        setTimeout(() => (this.hidden = true), 3500)
    },
}
</script>
